import { FORMAT_TYPES } from '../constants';

/**
 * Resolves the file extension for a mime type
 *
 * @param {string} type
 *
 * @return {string|false}
 */
export default function mimeExtension (type) {
  for (let format in FORMAT_TYPES) {
    if (FORMAT_TYPES[format].indexOf(type) !== -1) {
      return format;
    }
  }

  return false;
};